export const stylers = {
	styles: [
		{
			featureType: 'administrative',
			elementType: 'labels.text.fill',
			stylers: [
				{
					color: '#444444',
				},
			],
		},
	],
};
